import {
  getFillColor,
  supportsFillColor,
} from "../../utils/fillSelection";
import { floorplannerStore } from "../../store/floorplannerStore";
import { collectUsedNcsColors } from "./collectUsedNcsColors";
import type { NcsColorOption } from "./ncsColors";

/**
 * Scans live walls / fill-capable symbols for NCS colors already used in the
 * open plan. Must be called from an `observer` render (or MobX reaction) so
 * map updates re-run the scan.
 */
export function collectUsedNcsColorsFromPlan(): NcsColorOption[] {
  const fillColors: number[] = [];

  floorplannerStore.wallsMap.forEach((wall) => {
    fillColors.push(getFillColor(wall));
  });
  floorplannerStore.symbolsMap.forEach((symbol) => {
    if (supportsFillColor(symbol)) {
      fillColors.push(getFillColor(symbol));
    }
  });

  return collectUsedNcsColors({ fillColors });
}
